import { Component, Output, EventEmitter, Input } from '@angular/core';
import { MatterDispatch } from '@state/matter';
import { MatterFieldMappings, MatterFields } from '@models/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { AI_GENERATED_ICON, ICON } from '@core/util/icon';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { TestHooks } from './sale-price.hooks';
import { Select, Store } from '@ngxs/store';
import { DocumentProcessorService } from '@services/document-ai/document-processor.service';
import { MatterDocumentType } from '@models/matter-file';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
	selector: 'app-sale-saleprice',
	templateUrl: './sale-price.component.html',
	standalone: false,
})
export class SalePriceComponent {
	testHooks = TestHooks;
	@Output() onFocus = new EventEmitter<string>();
	@SelectSnapshot(SelectedMatter.id) saleId: string;
	@Select(SelectedMatter.getFieldMappings)
	fieldMappings$: Observable<MatterFieldMappings>;

	AI_ICON = AI_GENERATED_ICON.icon;
	AI_TOOLTIP = AI_GENERATED_ICON.tooltip;
	AI_CLASSES = AI_GENERATED_ICON.classes;

	salePrice$ = this.store.select(SelectedMatter.purchasePrice);

	isLoading$ = combineLatest(
		[
			MatterDocumentType.APS,
			MatterDocumentType.BUYER_COMMISSION_STATEMENT,
			MatterDocumentType.SELLER_COMMISSION_STATEMENT,
		].map((type) => this.documentProcessorService.isLoading$(type)),
	).pipe(map((loading) => loading.some((l) => l)));

	public field = MatterFields.PURCHASE_PRICE;
	public ICON = ICON;

	constructor(
		private matterDispatch: MatterDispatch,
		private documentProcessorService: DocumentProcessorService,
		private store: Store,
	) {}

	@Input() label: string;
	@Input() orientation = 'row';

	_onFocus() {
		this.onFocus.emit(this.field);
	}

	onChange = (salePrice: number) => {
		this.matterDispatch.SetSalePrice(this.saleId, salePrice);
	};
}
